import React from "react";
import AppInputPasswordFormik from "src/commun/composants/formulaire/formik/fields/AppInputPasswordFormik";
import { useAppText } from "src/commun/composants/AppText";
import { useFormikContext } from "formik";
import { UpdatePassword } from "src/pages/infoperso/connexion/module/password/useValidationSchemaPasswordUpdate";
import AppRow from "src/commun/composants/grille/AppRow";
import usePasswordCriterias from "src/commun/hooks/usePasswordCriterias";

export type PasswordUpdateFormContentProps = {
  displayCancelBtn?: boolean;
  cancelCallback?: () => void;
};

const PasswordUpdateFormContent = ({ displayCancelBtn, cancelCallback }: PasswordUpdateFormContentProps) => {

  const passwordCriterias = usePasswordCriterias();
  const { tString } = useAppText();
  const { submitCount, submitForm } = useFormikContext<UpdatePassword>();

  return (
    <>
      <div className="mt-3">
        <AppInputPasswordFormik
          name="currentPassword"
          label={tString("update.password.current")}
          formulaireSoumis={submitCount > 0}
        />
      </div>

      <AppInputPasswordFormik
        name="newPassword"
        label={tString("update.password.new")}
        criterias={passwordCriterias}
        formulaireSoumis={submitCount > 0}
      />

      <div className="mt-3">
        <AppInputPasswordFormik
          name="newPasswordConfirmation"
          label={tString("update.password.new.repeat")}
          formulaireSoumis={submitCount > 0}
        />
      </div>

      <AppRow>
        {displayCancelBtn &&
            <input
                className="btn__primary mt-3 mr-3 btn--full--xs"
                type="submit"
                name="annuler"
                onClick={cancelCallback}
                value={tString("update.password.cancel.button")}
            />
        }
        <input
          className="btn__primary mt-3 btn--full--xs"
          type="submit"
          name="submit"
          onClick={submitForm}
          value={tString("update.password.valid.button")}
        />
      </AppRow>
    </>
  );
};

export default PasswordUpdateFormContent;